/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown>, total: NonNullable<unknown> }} Common_Table_Page_InfoInputs */

const en_common_table_page_info = /** @type {(inputs: Common_Table_Page_InfoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Page ${i?.current} of ${i?.total}`)
};

const zh_common_table_page_info = /** @type {(inputs: Common_Table_Page_InfoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`第 ${i?.current} 页，共 ${i?.total} 页`)
};

/**
* | output |
* | --- |
* | "Page {current} of {total}" |
*
* @param {Common_Table_Page_InfoInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_table_page_info = /** @type {((inputs: Common_Table_Page_InfoInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Table_Page_InfoInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_table_page_info(inputs)
	return zh_common_table_page_info(inputs)
});
export { common_table_page_info as "common.table.page_info" }